import { useState, useEffect } from 'react';

/**
 * Custom Hook to track page scroll status.
 * @param threshold - The number of pixels to scroll before the state changes.
 * @returns boolean indicating if the threshold has been crossed.
 */
export const useScroll = (threshold: number = 20): boolean => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > threshold);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Initial check
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [threshold]);

  return isScrolled;
};
